import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Settings } from 'lucide-react';

interface Props {
  hasConfig: boolean;
  children: React.ReactNode;
}

export const ConfigGate: React.FC<Props> = ({ hasConfig, children }) => {
  const navigate = useNavigate();
  const { projectId } = useParams<{ projectId: string }>();

  if (!hasConfig) {
    return (
      <div className="flex flex-col items-center justify-center py-24 gap-4">
        <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center">
          <Settings size={28} className="text-amber-500" />
        </div>
        <div className="text-center">
          <p className="text-navy font-semibold text-base">Engagement not configured</p>
          <p className="text-slate-500 text-sm mt-1">Complete the engagement configuration before accessing this tool.</p>
        </div>
        <button
          onClick={() => navigate(`/projects/${projectId}/reach/config`)}
          className="flex items-center gap-2 rounded-xl h-10 px-6 bg-primary hover:bg-primary-dark transition-colors text-white text-sm font-bold shadow-sm"
        >
          <Settings size={16} /> Configure Engagement
        </button>
      </div>
    );
  }

  return <>{children}</>;
};
